import React from "react";
import { ClarificationModalWithChat } from "../../../ClarificationModalWithChat";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const ClarificationModalWrapper: React.FC = () => {
  const { data, modals, props } = useClarificationsRegisterContext();
  const { clarifications, clarificationTypes, unreadCounts, updateLocalClarifications } = data;
  const { isModalOpen, selectedClarification, handleCloseModal, handleSave, handleResponseSave } = modals;
  const { isClientView, supplierName, rfxId } = props;

  return (
    <ClarificationModalWithChat
      isOpen={isModalOpen}
      onChatOpened={() => {
        if (selectedClarification?.conversation_unread_count && selectedClarification.conversation_unread_count > 0) {
          updateLocalClarifications(
            clarifications.map((c) =>
              c.id === selectedClarification.id ? { ...c, conversation_unread_count: 0 } : c
            )
          );
        }
      }}
      onClose={handleCloseModal}
      clarification={selectedClarification}
      clarificationTypes={clarificationTypes}
      isClientView={isClientView}
      supplierName={supplierName}
      onClientSave={handleSave}
      onSupplierSave={handleResponseSave}
      rfxId={rfxId}
      unreadCount={selectedClarification ? (unreadCounts.get(selectedClarification.id) || 0) : 0}
    />
  );
};
